export const PEEL_NOTES = [
  {
    heading: 'What peel is (and is not)',
    body: [
      'You are peeling die-attach off a pad at ~90°. The number is force per width (N/mm). Die shear (a button of die pushed sideways, often discussed with MIL-STD-883 methods) is a different stress state. Do not quote peel as shear or the other way around. Interfacial (adhesive) fails at the pad or die; cohesive fails inside the DA. Plasma is a surface play. Chemistry is a bulk play. Cure is a conversion play.',
    ],
  },
  {
    heading: 'The hidden model in this gripper',
    body: [
      'Mean peel ≈ 0.40 + 0.31·plasma + 0.055·(cure−150)/30 + 0.025·(adhesive B) + small noise, in N/mm. Plasma is first-order. Cure is second. New chemistry is a rounding error until the pad is clean. That is deliberate: organic leadframe / die backsides in the wild often lose more to contamination than to the datasheet DA.',
    ],
    list: [
      'Plasma “on” is a clean, activated organic surface — not a magic coating.',
      '150 °C vs 180 °C is under-cure vs a more complete network. Under-cure can look like a materials problem.',
      'Adhesive B is a slightly tougher bulk. If plasma is off, B will not save you.',
    ],
  },
  {
    heading: 'How to read your table like a line engineer',
    body: [
      'A main effect is the difference in average peel when a factor flips, averaging over the others. You cannot trust plasma’s effect if you never ran both plasma states. One heroic pull is an anecdote. You need both levels — then a replicate if you will spend money.',
    ],
    list: [
      'If plasma Δ ≫ chemistry Δ: clean the pad, do not open a new DA qualification this week.',
      'If cure Δ is large and plasma is already on: you may be under-cured (voids, low conversion), not “wrong epoxy”.',
      'If everything is flat: either the joint is already good or your window is too narrow — widen the factor, do not add decimals.',
    ],
  },
  {
    heading: 'Typical sense-check (not a spec)',
    body: [
      'Organic DA peel on a clean pad is often in the several 0.1 N/mm class in coupon work; dirty pads can sit near the floor of this gripper. A real qualification uses a written method, width, rate, and failure-mode photos. If the senior asks for “the spec”, the answer is the customer’s die-attach spec and the failure mode, not a number you invented in this lab.',
    ],
  },
  {
    heading: 'Where this gripper is a lie',
    body: [
      'No rate effect, no temperature, no moisture, no fillet geometry, no die size, no leadframe plating (Ag / NiPdAu / Cu OSP behave differently). Plasma here is a bit. In the factory it is gas, power, time, and time-to-dispense. Wait too long after plasma and the pad dies again.',
    ],
  },
];
